// LOAD ALL THE READ ONLY DATA
import { makeSetReducer } from "./utils";

export const poblacionesFullfilledReducer = makeSetReducer(['poblaciones/fullfilled']);
